import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container, Input, Select, Button } from 'semantic-ui-react';
import { Map, TileLayer, Marker, Popup } from 'react-leaflet';
// import _ from 'lodash';
import { GEO_CONSTANTS } from '../../config/constants';

class MapSearchAndSelect extends Component {
  static propTypes = {
    height: PropTypes.number, // search field not included
    width: PropTypes.number,
    selectPosition: PropTypes.func,
    currentSelection: PropTypes.object, // {lat, lng}
    markerType: PropTypes.string, // 'Information' ou 'Alerte'
  };

  static defaultProps = {
    width: null,
    height: 500,
    selectPosition: (lat, lng, name) => console.log(lat, lng, name),
    currentSelection: null,
    markerType: 'Information',
  }

  constructor(props) {
    super(props);
    this.state = {
      searchInput: '',
      searching: false,
      targetPosition: null,
      targetName: '',
    };
  }

  handleSearchAction = () => {
    if (this.state.searchInput.length < 2) {
      return null;
    }
    this.setState({ searching: true });
    let range;
    switch (this.state.searchRange) {
      case 'ggd':
        range = `${GEO_CONSTANTS.ggdCounty}, ${GEO_CONSTANTS.country}`;
        break;
      case 'nat':
        range = GEO_CONSTANTS.country;
        break;
      default:
        range = `${GEO_CONSTANTS.ggdCounty}, ${GEO_CONSTANTS.country}`;
        break;
    }

    const searchQuery = `${this.state.searchInput}, ${range}`;

    return fetch(
      `${GEO_CONSTANTS.urls.search}/${encodeURIComponent(searchQuery)}?format=jsonv2&limit=1&exclude_place_ids=177463179`,
      { method: 'GET' },
    ).then(resp => resp.json()).then((res) => {
      if (res.length < 1) {
        return this.setState({ searching: false });
      }
      // console.log(res[0]);
      return this.setState({
        searching: false,
        targetPosition: [parseFloat(res[0].lat), parseFloat(res[0].lon)],
        targetName: res[0].display_name,
      });
    });
  }

  handleSelectPosition = () => {
    if (!this.state.targetPosition || this.state.targetPosition.length !== 2) {
      return null;
    }
    return this.props.selectPosition(this.state.targetPosition[0], this.state.targetPosition[1], this.state.targetName);
  }

  updatePosition = () => {
    // console.log(this.marker);
    if (!this.marker.leafletElement || typeof this.marker.leafletElement.getLatLng !== 'function') {
      return null;
    }
    this.setState({ searching: true });
    const { lat, lng } = this.marker.leafletElement.getLatLng();
    fetch(
      `${GEO_CONSTANTS.urls.reverseGeocode}?format=jsonv2&lat=${lat}&lon=${lng}&zoom=16`,
      { method: 'GET' },
    ).then(resp => resp.json()).then(res =>
      this.setState({
        searching: false,
        targetName: res.display_name,
      }));
    // console.log(`${GEO_CONSTANTS.urls.reverseGeocode}?format=jsonv2&lat=${lat}&lon=${lng}&zoom=16`);
    // console.log(lat, res.lat, lng, res.lon, res.display_name);
    return this.setState({
      targetPosition: [lat, lng],
    });
  }

  marker;

  render() {
    const { width, height } = this.props;
    const mapProps = {};
    const { lat, lng, zoom } = GEO_CONSTANTS.initialPosAndZoom;
    let markerLat = 0;
    let markerLng = 0;

    if (this.state.targetPosition) {
      markerLat = this.state.targetPosition[0];
      markerLng = this.state.targetPosition[1];
      mapProps.center = [markerLat, markerLng];
    } else {
      mapProps.center = [lat, lng];
      mapProps.zoom = zoom;
    }

    const styles = {};
    if (width) {
      styles.width = width;
    }
    if (height) {
      styles.minHeight = height;
      styles.height = height;
    }
    const options = [
      { key: 'ggd', value: 'ggd', text: 'Groupement' },
      { key: 'nat', value: 'nat', text: 'National' },
    ];

    return (
      <Container>
        <Input
          fluid
          type="text"
          placeholder="Rechercher..."
          action
          disabled={this.state.searching}
          value={this.state.searchInput}
          onChange={(e, { value }) => this.setState({ searchInput: value })}
          onKeyPress={e => (e.key === 'Enter' ? this.handleSearchAction() : null)}
        >
          <input />
          <Select
            compact
            options={options}
            defaultValue="ggd"
            onChange={(e, { value }) => this.setState({ searchRange: value })}
          />
          <Button
            icon="search"
            type="submit"
            loading={this.state.searching}
            disabled={this.state.searchInput.length < 2}
            onClick={this.handleSearchAction}
          />
        </Input>
        <Map
          {...mapProps}
          style={styles}
          useFlyTo
        >
          <TileLayer
            attribution="&amp;copy <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
            url="https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png"
          />
          {this.state.targetPosition
          && (
            <Marker
              position={this.state.targetPosition}
              draggable
              autoPan
              onDragend={this.updatePosition}
              ref={(ref) => {
                this.marker = ref;
                return true;
              }}
            >
              <Popup><p>{this.state.targetName}</p></Popup>
            </Marker>
          )
          }

        </Map>
        <Button
          attached="bottom"
          fluid
          color={!this.state.targetPosition ? 'grey' : 'orange'}
          content={!this.state.targetPosition ? 'Aucune géolocalisation sélectionnée' : 'Valider cette géolocalisation'}
          icon={!this.state.targetPosition ? null : 'checkmark'}
          disabled={!this.state.targetPosition || this.state.searching}
          onClick={this.handleSelectPosition}
        />
      </Container>
    );
  }
}

export default MapSearchAndSelect;



// WEBPACK FOOTER //
// ./src/components/Maps/MapSearchAndSelect.js